import React from 'react';
import PropTypes from 'prop-types';
import { getUrlParams } from '../../../../utils/shared/urlUtils';
import ProgressGrid from '../ProgressGrid';
import { GROWTH_ANALYSIS_SORTABLE_COLUMNS } from '../../../../constants/shared/GrowthAnalysisConstants';

const GrowthAnalysisTable = ({
    resultsByGrades,
    periodObject,
    location,
    openProbeDetails,
    gradeToMeasureMapper,
    ProbeDetailsPageContainer,
    getRowsToRender,
    appSpecificParams,
}) => {
    const { colSpans, rows } = getRowsToRender({
        resultsByGrades,
        periodObject,
        location,
        openProbeDetails,
        gradeToMeasureMapper,
        appSpecificParams,
    });

    const { resultId } = getUrlParams(location);
    return (
        <>
            {resultId && <ProbeDetailsPageContainer resultId={resultId} />}
            <ProgressGrid
                gridKey={`${periodObject.startPeriod}${periodObject.endPeriod}`}
                colSpans={colSpans}
                rows={rows}
                sortableColumns={GROWTH_ANALYSIS_SORTABLE_COLUMNS}
            />
        </>
    );
};

GrowthAnalysisTable.defaultProps = {
    resultsByGrades: [],
    location: {},
    periodObject: {},
    openProbeDetails: () => {},
    gradeToMeasureMapper: [],
    ProbeDetailsPageContainer: {},
    getRowsToRender: () => {},
    appSpecificParams: {},
};

GrowthAnalysisTable.propTypes = {
    resultsByGrades: PropTypes.array,
    periodObject: PropTypes.object,
    location: PropTypes.object,
    openProbeDetails: PropTypes.func,
    gradeToMeasureMapper: PropTypes.array,
    ProbeDetailsPageContainer: PropTypes.object,
    getRowsToRender: PropTypes.func,
    appSpecificParams: PropTypes.object,
};

export default GrowthAnalysisTable;
